import React from 'react';

const VerifyLink = () => {
    return (
        <div>
             this is verify link
        </div>
    );
};

export default VerifyLink;